import { CloseIcon } from "@chakra-ui/icons";
import { Box, Button, Flex, Grid, Input, Text, Tooltip } from "@chakra-ui/react";
import apiCarteira from "api/api-carteira";
import { getErrorPadrao } from "components/atendimentos-components/atendimento-form/functions/mapeamentos";
import { CustomModal } from "components/custom-modal";
import Dropdown from "components/dropdown";
import { Toast } from "components/toast";
import { CashIcon } from "components/vectors/cash-icon";
import { getTitle } from "components/white-label";
import { useState } from "react";
import { makeEvent, useEventListener } from "services/events";
import { currencyMaskFormat } from "utils/string-formats";

const initialValue = {
    tipoCarteira: "GERAL",
    value: 0,
};

export function ModalAdicionarSaldoStorm({
    updateTransacoes,
}: {
    updateTransacoes: () => Promise<void>;
}) {
    const [isOpen, setIsOpen] = useState(false);
    const [modalData, setModalData] = useState(initialValue);
    const [isLoading, setIsLoading] = useState(false);
    const title = getTitle() === "Nova Promotora" ? "Grupo Nova" : getTitle();
    const modalTitle = "Adicione Saldo via C/C " + title;

    const onOpen = () => {
        setIsOpen(true);
    }

    const onClose = () => {
        setIsOpen(false);
        setModalData(initialValue);
        setIsLoading(false);
        updateTransacoes();
    }

    useEventListener("openModalAdicionarSaldoStorm", onOpen);

    const isDisabledDepositarCCStorm = !modalData.value || modalData.value < 20;

    const handleSubmit = async () => {
        if (!isDisabledDepositarCCStorm) {
            console.log("body -> ", modalData);
            setIsLoading(true);
            try {
                await apiCarteira.post(`/cobrancas/cc-storm`, modalData);
                onClose();
            } catch (e: any) {
                const { msgInterface } = getErrorPadrao(e);
                Toast({
                    title: "Erro ao realizar deposito",
                    description: msgInterface,
                    status: "error",
                    duration: 10000,
                });
            } finally {
                setIsLoading(false);
            }
        }
    }

    const modalFooter = (
        <>
            <Tooltip label={isDisabledDepositarCCStorm ? "Preencha o valor a ser depositado" : undefined}>
                <Button
                    onClick={handleSubmit}
                    opacity={isDisabledDepositarCCStorm ? 0.5 : undefined}
                    leftIcon={<CashIcon width="18px" height="18px" />}
                >
                    Depositar
                </Button>
            </Tooltip>
            <Button
                onClick={onClose}
                variant="outline"
                leftIcon={<CloseIcon w="12px" h="12px" />}
            >
                Fechar
            </Button>
        </>
    );

    const tipoCarteiraArray = [
        {
            name: "Geral",
            value: "GERAL",
        },
        {
            name: "Fgts",
            value: "FGTS",
        },
    ];

    return (
        <CustomModal
            isOpen={isOpen}
            onClose={onClose}
            modalTitle={modalTitle}
            size="md"
            modalFooter={modalFooter}
            isLoading={isLoading}
            containerProps={{ alignItems: "flex-start", py: "40px" }}
        >
            <Grid w="100%" gap="15px">
                <Box mb="10px">
                    <Text mb="8px">Carteira:</Text>
                    <Dropdown
                        options={tipoCarteiraArray}
                        w="100%"
                        isDisabled={isLoading}
                        placeholder={tipoCarteiraArray[0].name}
                        defaultValue={tipoCarteiraArray[0].value}
                        value={modalData.tipoCarteira}
                        onChange={(value) => {
                            console.log("tipo carteira: " + value);
                            setModalData({ ...modalData, tipoCarteira: value })
                        }}
                    />
                </Box>
                <Box>
                    <Text mb="8px">Valor (min. R$ 20,00):</Text>
                    <Input
                        value={currencyMaskFormat(modalData.value).value}
                        onChange={(e) =>
                            setModalData({
                                ...modalData,
                                value: currencyMaskFormat(e.target.value).raw,
                            })
                        }
                    />
                </Box>
            </Grid>
        </CustomModal>
    )
}

export const openModalAdicionarSaldoStorm = () =>
    makeEvent("openModalAdicionarSaldoStorm");